var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveRegenerateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4661_32179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#949494"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4661_32179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.30606 13.0225C4.05398 12.5534 3.86356 12.0692 3.73481 11.5697C3.60606 11.0702 3.54169 10.5608 3.54169 10.0416C3.54169 8.23926 4.16884 6.70537 5.42315 5.43995C6.67745 4.1744 8.20308 3.54162 10 3.54162H10.6506L9.10898 1.99995L9.9871 1.12183L13.0321 4.16662L9.9871 7.21141L9.10898 6.33328L10.6506 4.79162H10C8.55238 4.79162 7.32238 5.3012 6.31002 6.32037C5.2978 7.33967 4.79169 8.58009 4.79169 10.0416C4.79169 10.3868 4.82933 10.7315 4.9046 11.076C4.98002 11.4206 5.09301 11.7569 5.24356 12.085L4.30606 13.0225ZM10.0129 18.8781L6.96794 15.8333L10.0129 12.7885L10.8911 13.6666L9.3494 15.2083H10C11.4477 15.2083 12.6777 14.6987 13.69 13.6795C14.7022 12.6602 15.2084 11.4198 15.2084 9.95829C15.2084 9.61315 15.1707 9.26835 15.0954 8.92391C15.02 8.57933 14.907 8.24301 14.7565 7.91495L15.694 6.97745C15.9461 7.44648 16.1365 7.93072 16.2652 8.43016C16.394 8.92974 16.4584 9.43912 16.4584 9.95829C16.4584 11.7606 15.8312 13.2945 14.5769 14.56C13.3226 15.8255 11.797 16.4583 10 16.4583H9.3494L10.8911 18L10.0129 18.8781Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRegenerateIcon);
export default __webpack_public_path__ + "static/media/active-regenerate-icon.b6b470f4c62b9c12a105da2ebc90c35d.svg";
export { ForwardRef as ReactComponent };